import { motion, useMotionValueEvent, useScroll } from "framer-motion";
import { useRef, useState } from "react";
import { BsTools } from "react-icons/bs";
import { tools } from "../../constants/tools";
import { FeatureIconContainer } from "../features/feature-icon-container";
import { Heading } from "../ui/heading";
import { StickyScroll } from "../ui/sticky-scroll";
import { Subheading } from "../ui/subheading";

export const Tools = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const backgrounds = [
    "bg-gradient-to-tr from-gray-900/10 via-black/10 to-fuchsia-600/10",
    "bg-gradient-to-tr from-black/10 via-pink-600/10 to-gray-900/10",
    "bg-gradient-to-tr from-fuchsia-700/10 via-gray-900/10 to-black/10",
    "bg-gradient-to-tr from-gray-900/10 via-black/10 to-fuchsia-600/10",
  ];

  const [gradient, setGradient] = useState(backgrounds[0]);

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    const cardsBreakpoints = tools.map(
      (_, index) => (index + 1) / tools.length
    );
    const closestBreakpointIndex = cardsBreakpoints.reduce(
      (acc, breakpoint, index) => {
        const distance = Math.abs(latest - breakpoint);
        if (distance < Math.abs(latest - cardsBreakpoints[acc])) {
          return index;
        }
        return acc;
      },
      0
    );

    if (closestBreakpointIndex !== undefined) {
      const newGradient =
        backgrounds[closestBreakpointIndex % backgrounds.length];
      if (newGradient !== gradient) {
        setGradient(newGradient);
        // console.log(`Applying gradient: ${newGradient}`);
      }
    }
  });

  return (
    <motion.div
      className={`${gradient} w-full relative h-full pt-24`}
      ref={ref}
      transition={{
        duration: 0.5,
      }}
    >
      <div className="px-4 hidden md:block" data-aos="fade-down">
        <FeatureIconContainer className="flex justify-center items-center overflow-hidden">
          <BsTools className="h-6 w-6 text-fuchsia-700" />
        </FeatureIconContainer>
        <Heading className="mt-4">The Ultimate Store Management Tools</Heading>
        <Subheading>
          Whizmanage offers a suite of tools to streamline your WooCommerce
          store management.
        </Subheading>
      </div>
      <div className="px-4 md:hidden">
        <FeatureIconContainer className="flex justify-center items-center overflow-hidden">
          <BsTools className="h-6 w-6 text-fuchsia-700" />
        </FeatureIconContainer>
        <Heading className="mt-4">The Ultimate Store Management Tools</Heading>
        <Subheading>
          Whizmanage offers a suite of tools to streamline your WooCommerce
          store management.
        </Subheading>
      </div>
      <StickyScroll content={tools} />
    </motion.div>
  );
};


